module.exports = __webpack_public_path__ + "static/media/sunlight.79eca6df.svg";